<template>
  <div class="user-email">
        <div class="title-form">
            <h1>Email sent!</h1>
            <span class="bigger"> Check your <span class="email"> {{email}} </span> inbox for instructions from us on how to reset your
                password. </span>
        </div>
  </div>
</template>

<script>

export default {
  name: 'password_sent',
  data () {
    return {
      email: this.$route.params.email
    }
  }
}
</script>

<style lang="scss">

.email {
    font-weight: bold;
}

.user-email {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: auto;
    width: 500px;
    max-width: 100%;
    text-align: left;
    justify-content: center;
    vertical-align: middle;
}

</style>
